import * as types from './types';

export const state = {
  activePost: {
    medias: [],
  },
  userPostHit: {},
};

export const mutations = {
  [types.SET_ACTIVE_POST](state, activePost) {
    state.activePost = activePost;
  },
  [types.RESET_ACTIVE_POST](state) {
    state.activePost = {
      medias: [],
    };
  },
  [types.SET_USER_POST_HIT](state, userPostHitId) {
    state.userPostHit = { id: userPostHitId };
  },
};



// WEBPACK FOOTER //
// ./src/screens/Class/Index/store/mutations.js